var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgProposallisting(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 50 66.67",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M8.33,35.42a2.09,2.09,0,1,1,2.09,2.08,2.1,2.1,0,0,1-2.09-2.08m2.09,6.25a2.08,2.08,0,1,0,2.08,2.08,2.09,2.09,0,0,0-2.08-2.08M8.33,52.08a2.09,2.09,0,1,1,2.09,2.09,2.09,2.09,0,0,1-2.09-2.09M18.75,33.33a2.09,2.09,0,0,0,0,4.17H39.58a2.09,2.09,0,1,0,0-4.17ZM16.67,43.75a2.08,2.08,0,0,1,2.08-2.08H39.58a2.08,2.08,0,1,1,0,4.16H18.75a2.08,2.08,0,0,1-2.08-2.08M18.75,50a2.09,2.09,0,0,0,0,4.17H39.58a2.09,2.09,0,1,0,0-4.17ZM8.33,0A8.33,8.33,0,0,0,0,8.33v50a8.33,8.33,0,0,0,8.33,8.34H41.67A8.33,8.33,0,0,0,50,58.33V22.56a6.25,6.25,0,0,0-1.83-4.42L31.86,1.83A6.25,6.25,0,0,0,27.44,0ZM4.17,8.33A4.16,4.16,0,0,1,8.33,4.17H25V18.75A6.25,6.25,0,0,0,31.25,25H45.83V58.33a4.17,4.17,0,0,1-4.16,4.17H8.33a4.17,4.17,0,0,1-4.16-4.17ZM45,20.83H31.25a2.08,2.08,0,0,1-2.08-2.08V5Z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProposallisting);
export default __webpack_public_path__ + "static/media/proposal listing.5804a3184ac50b2ad81670d3c8abbaad.svg";
export { ForwardRef as ReactComponent };